<template>
  <RevCard class="px-8 py-7">
    <RevContentBlock
      :button-label="i18n(translations.backToListings)"
      :image-props
      :surtitle="i18n(translations.surtitle)"
      :title="i18n(translations.title)"
      :to="{
        name: isListingsPageV2Default
          ? ROUTE_NAMES.ONBOARDING.LISTINGSV2.INDEX
          : ROUTE_NAMES.ONBOARDING.LISTINGS.INDEX,
      }"
    >
      <span class="body-1">
        {{ i18n(translations.description) }}
      </span>
    </RevContentBlock>
  </RevCard>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContentBlock } from '@ds/components/ContentBlock'

import { ROUTE_NAMES } from '~/constants/routes'
import { useListingPagePreference } from '~/scopes/listings/pages/listingsV2/composables/useListingPagePreference'

import translations from './Confirmation.translations'

const { isListingsPageV2Default } = useListingPagePreference()

const i18n = useI18n()

const imageProps = {
  alt: '',
  height: 257,
  src: '/img/options/payment/review.svg',
  width: 465,
}
</script>
